var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.183,
    height: 322.886,
    viewBox: "0 0 275.183 322.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7187",
    "data-name": "Trazado 7187",
    d: "M130.23,277.892l-13.1-51.541L13.673,252.645,0,198.847,82.676,10.422,123.683,0l39.872,156.878,33.106-8.414,13.768,54.176-33.106,8.414,13.1,51.541ZM59.345,183.363l51.165-13-16.924-66.59Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 71.924, 0)",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Error);
export default __webpack_public_path__ + "static/media/4Error.e26d63259c4e3aacb50b5da8c2456cf9.svg";
export { ForwardRef as ReactComponent };